<template>
  <el-dialog
    :title="activeItem instanceof Array ? '批操作' : '关闭工单'"
    :visible.sync="$parent.handleDialog"
    width="30%"
    top="35vh"
  >
    <el-form :model="form" :rules="rules" ref="ruleForm" label-width="80px">
      <template v-if="activeItem instanceof Array ? true : false">
        <el-form-item label="批处理" prop="handleSelect">
          <el-radio-group v-model="form.handleSelect">
            <el-radio label="确认" :disabled="showConfirm">确认</el-radio>
            <el-radio label="派单" :disabled="showDistribution">派单</el-radio>
            <el-radio label="关闭" :disabled="showClose">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="处理人"
          prop="user"
          v-if="form.handleSelect == '派单'"
          key="user"
        >
          <el-select
            v-model="form.user"
            multiple
            collapse-tags
            placeholder="请选择处理人"
          >
            <el-option
              v-for="item in userAllList"
              :key="item.userId"
              :label="item.userName"
              :value="item.userId"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </template>
      <el-form-item
        label="关闭原因"
        prop="reason"
        v-if="form.handleSelect == '关闭'"
        key="reason"
      >
        <el-radio-group v-model="form.reason">
          <el-radio label="无需处理">无需处理</el-radio>
          <el-radio label="无效工单">无效工单</el-radio>
          <el-radio label="重复工单">重复工单</el-radio>
          <el-radio label="其他">其他</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="关闭原因"
        prop="desc"
        v-if="form.reason == '其他' && form.handleSelect == '关闭'"
      >
        <el-input
          type="textarea"
          v-model="form.desc"
          placeholder="原因"
          maxlength="50"
          rows="3"
          resize="none"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="$parent.handleDialog = false">取 消</el-button>
      <el-button
        type="primary"
        @click="confirmBtn('ruleForm')"
        :loading="btnLoading"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import api from "@/api";
export default {
  props: ["activeItem", "userAllList"],
  data() {
    return {
      btnLoading: false,
      showConfirm: false,
      showDistribution: false,
      showClose: false,
      form: {
        handleSelect: "",
        user: [],
        reason: "无需处理",
        desc: "",
      },
      rules: {
        handleSelect: [
          { required: true, message: "请选择处理内容", trigger: "change" },
        ],
        user: [{ required: true, message: "请选择处理人", trigger: "change" }],
        reason: [
          { required: true, message: "请选择关闭原因", trigger: "change" },
        ],
        desc: [
          { required: true, message: "关闭原因不能为空", trigger: "blur" },
          { whitespace: true, message: "关闭原因不能为空", trigger: "blur" },
          {
            min: 5,
            max: 50,
            message: "长度在 5 到 50 个字",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    processingLogic() {
      if (this.activeItem.every((v) => v.setStatus == "待确认")) {
        this.form.handleSelect = "确认";
        this.showClose = true;
      } else {
        let show = this.activeItem.some((v) => {
          if (v.setStatus == "待确认") {
            return true;
          }
        });
        if (show) {
          this.form.handleSelect = "派单";
          this.showConfirm = true;
          this.showClose = true;
        } else {
          this.form.handleSelect = "派单";
          this.showConfirm = true;
        }
      }
    },

    confirmBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          let data = {
            status:
              this.form.handleSelect == "确认"
                ? "COMPLETED"
                : this.form.handleSelect == "派单"
                ? "TOBE_REPAIR"
                : "INVALID",
            action:
              this.form.handleSelect == "确认"
                ? "CONFIRM"
                : this.form.handleSelect == "派单"
                ? "ASSIGN"
                : "CANCEL",
          };
          if (this.activeItem.id) {
            data.id = this.activeItem.id;
            data.remark =
              this.form.reason == "其他" ? this.form.desc : this.form.reason;
          } else {
            let ids = [];
            this.activeItem.forEach((v) => {
              ids.push(v.id);
            });
            data.ids = ids;
            if (this.form.handleSelect == "派单") {
              data.assignStaffIds = this.form.user;
            } else if (this.form.handleSelect == "关闭") {
              data.remark =
                this.form.reason == "其他" ? this.form.desc : this.form.reason;
            }
          }
          return new Promise(async (resolve) => {
            let res = await api.logisticsOrderOperation(data);
            if (res && res.data.code == 200) {
              this.btnLoading = false;
              this.$message.success("操作成功!");
              this.$parent.handleDialog = false;
              this.$store.commit("SET_LOADING", true);
              if (this.form.handleSelect != "派单") {
                this.$parent.resetSelection();
              }
              setTimeout(() => {
                this.$parent.getAllList();
              }, 1000);
            }
            resolve();
          });
        } else {
          return false;
        }
      });
    },
  },
  created() {
    if (this.activeItem instanceof Array) {
      this.processingLogic();
    } else {
      this.form.handleSelect = "关闭";
    }
  },
};
</script>

<style lang="scss" scoped>
</style>